import { render } from "./BudgetList.vue?vue&type=template&id=86bfc1c6"
import script from "./BudgetList.vue?vue&type=script&lang=js"
export * from "./BudgetList.vue?vue&type=script&lang=js"

import "./BudgetList.vue?vue&type=style&index=0&id=86bfc1c6&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__